import { render, staticRenderFns } from "./BreadcrumbConfig.vue?vue&type=template&id=a703a8a8&"
import script from "./BreadcrumbConfig.vue?vue&type=script&lang=ts&"
export * from "./BreadcrumbConfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports